import * as React from 'react'
import { usePaywallStore } from './usePaywallStore'
import { reasonLineFor } from './paywallCopy'
import {
    useContextsStore,
    selectLockedCount,
    selectOwnedTotal,
} from '../../stores/useContextsStore'

// The owner opened one of their locked graphs by URL. The server refused
// the graph read with QUOTA_GRAPH_LOCKED (the interceptor already opened the
// dialog); this replaces the "contact support" error with the reason and the
// two ways out. Public viewers never reach it — the lock is owner-only.
export default function LockedGraphScreen() {
    const openUpgradeDialog = usePaywallStore(state => state.openUpgradeDialog)
    const lockedCount = useContextsStore(selectLockedCount)
    const total = useContextsStore(selectOwnedTotal)
    const reason = { code: 'QUOTA_GRAPH_LOCKED', lockedCount, total }

    return (
        <div className="project-notes-scope">
            <div
                className="tw-fixed tw-inset-0 tw-z-[1250] tw-flex tw-items-center tw-justify-center tw-bg-background tw-p-6 tw-text-foreground"
                data-testid="locked-graph-screen"
            >
                <div className="tw-max-w-md tw-text-center">
                    <div className="tw-mb-3 tw-text-4xl" aria-hidden="true">
                        🔒
                    </div>
                    <h2 className="tw-m-0 tw-text-lg tw-font-semibold">
                        {reasonLineFor(reason)}
                    </h2>
                    <p className="tw-mb-5 tw-mt-2 tw-text-sm tw-text-muted-foreground">
                        Your {typeof total === 'number' ? total : ''} graphs are
                        kept. Deleting a locked graph frees nothing — the free
                        plan keeps your most recently updated ones open.
                    </p>
                    <div className="tw-flex tw-justify-center tw-gap-2">
                        <a
                            href="/apps"
                            className="tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-background tw-px-4 tw-py-2 tw-text-sm tw-text-foreground tw-no-underline"
                        >
                            Back to your graphs
                        </a>
                        <button
                            type="button"
                            onClick={() => openUpgradeDialog(reason)}
                            data-testid="locked-graph-upgrade"
                            className="tw-cursor-pointer tw-rounded-lg tw-border-0 tw-bg-primary tw-px-4 tw-py-2 tw-text-sm tw-font-semibold tw-text-primary-foreground"
                        >
                            Upgrade
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}
